import React, { useState, useEffect } from 'react'
import { Chart } from 'primereact/chart'
import { useAppSelector } from '../../../store/hooks'
import { chartColorVariants, type ChartDataProps } from './chartsUtil'
import ChartContainer from './ChartContainer'

interface BarChartProps {
    data?: ChartDataProps
}

const BarChart = ({ data }: BarChartProps) => {
    const theme = useAppSelector((state) => state.theme.theme)

    const [chartData, setChartData] = useState<ChartDataProps | Record<string, unknown> | undefined>({})
    const [chartOptions, setChartOptions] = useState<Record<string, unknown>>({})

    useEffect(() => {
        const documentStyle = getComputedStyle(document.documentElement)
        const textColor = documentStyle.getPropertyValue(
            theme === 'dark' ? '--bs-white' : '--bs-black'
        )
        const textColorSecondary = documentStyle.getPropertyValue(
            '--text-color-secondary'
        )
        const surfaceBorder =
            documentStyle.getPropertyValue('--bs-border-color')

        const options = {
            maintainAspectRatio: false,
            aspectRatio: 0.7,
            plugins: {
                legend: {
                    labels: {
                        color: textColor,
                    },
                },
            },
            scales: {
                x: {
                    ticks: {
                        color: textColorSecondary,
                    },
                    grid: {
                        color: surfaceBorder,
                    },
                },
                y: {
                    ticks: {
                        color: textColorSecondary,
                    },
                    grid: {
                        color: surfaceBorder,
                    },
                },
            },
        }

        const finalisedChartData = data
        const dataSets = data?.datasets ?? []

        for (let i = 0; i < dataSets.length; i++) {
            const ds = dataSets[i]
            if (!ds) continue
            ds['type'] = 'bar'
            ds['borderWidth'] = 1
            ds['fill'] = true

            const colorVariant = chartColorVariants[i]

            if (colorVariant) {
                ds['borderColor'] =
                    documentStyle.getPropertyValue('--bs-' + colorVariant)
                ds['backgroundColor'] =
                    documentStyle.getPropertyValue('--bs-' + colorVariant) +
                    '30'
            }
        }

        setChartData(finalisedChartData)
        setChartOptions(options)
    }, [theme, data])

    return (
        <ChartContainer>
            <Chart type="line" data={chartData} options={chartOptions} />
        </ChartContainer>
    )
}

export default BarChart
